import { UKEnergyProduct } from 'src/models/enums/products';
import { ProductTimeMap } from 'src/types/product-time-map';

export const LONG_PRODUCTS_NORMAL_GMT: ProductTimeMap = {
  [UKEnergyProduct.BASELOAD]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 23,
    duration: 24,
  },
  [UKEnergyProduct.OFFPEAK]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 7,
    duration: 8,
  },
  [UKEnergyProduct.PEAK]: {
    dateOffsetDays: 0,
    startUTCHour: 7,
    endUTCHour: 19,
    duration: 12,
  },
  [UKEnergyProduct.EXTENDED_PEAK]: {
    dateOffsetDays: 0,
    startUTCHour: 7,
    endUTCHour: 23,
    duration: 16,
  },
};

export const LONG_PRODUCTS_NORMAL_BST: ProductTimeMap = {
  [UKEnergyProduct.BASELOAD]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 22,
    duration: 24,
  },
  [UKEnergyProduct.OFFPEAK]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 6,
    duration: 8,
  },
  [UKEnergyProduct.PEAK]: {
    dateOffsetDays: 0,
    startUTCHour: 6,
    endUTCHour: 18,
    duration: 12,
  },
  [UKEnergyProduct.EXTENDED_PEAK]: {
    dateOffsetDays: 0,
    startUTCHour: 6,
    endUTCHour: 22,
    duration: 15,
  },
};

export const LONG_PRODUCTS_OCTOBER_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.BASELOAD]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 23,
    duration: 25,
  },
  [UKEnergyProduct.OFFPEAK]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 7,
    duration: 9,
  },
};

export const LONG_PRODUCTS_MARCH_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.BASELOAD]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 22,
    duration: 23,
  },
  [UKEnergyProduct.OFFPEAK]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 6,
    duration: 7,
  },
};

export const EFA_BLOCKS_NORMAL_GMT: ProductTimeMap = {
  [UKEnergyProduct.EFA1]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 3,
    duration: 4,
  },
  [UKEnergyProduct.EFA2]: {
    dateOffsetDays: 0,
    startUTCHour: 3,
    endUTCHour: 7,
    duration: 4,
  },
  [UKEnergyProduct.EFA3]: {
    dateOffsetDays: 0,
    startUTCHour: 7,
    endUTCHour: 11,
    duration: 4,
  },
  [UKEnergyProduct.EFA4]: {
    dateOffsetDays: 0,
    startUTCHour: 11,
    endUTCHour: 15,
    duration: 4,
  },
  [UKEnergyProduct.EFA5]: {
    dateOffsetDays: 0,
    startUTCHour: 15,
    endUTCHour: 19,
    duration: 4,
  },
  [UKEnergyProduct.EFA6]: {
    dateOffsetDays: 0,
    startUTCHour: 19,
    endUTCHour: 23,
    duration: 4,
  },
};

export const EFA_BLOCKS_NORMAL_BST: ProductTimeMap = {
  [UKEnergyProduct.EFA1]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 2,
    duration: 4,
  },
  [UKEnergyProduct.EFA2]: {
    dateOffsetDays: 0,
    startUTCHour: 2,
    endUTCHour: 6,
    duration: 4,
  },
  [UKEnergyProduct.EFA3]: {
    dateOffsetDays: 0,
    startUTCHour: 6,
    endUTCHour: 10,
    duration: 4,
  },
  [UKEnergyProduct.EFA4]: {
    dateOffsetDays: 0,
    startUTCHour: 10,
    endUTCHour: 14,
    duration: 4,
  },
  [UKEnergyProduct.EFA5]: {
    dateOffsetDays: 0,
    startUTCHour: 14,
    endUTCHour: 18,
    duration: 4,
  },
  [UKEnergyProduct.EFA6]: {
    dateOffsetDays: 0,
    startUTCHour: 18,
    endUTCHour: 22,
    duration: 4,
  },
};

export const EFA_BLOCKS_OCTOBER_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.EFA1]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 3,
    duration: 3,
  },
};

export const EFA_BLOCKS_MARCH_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.EFA1]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 2,
    duration: 5,
  },
};

export const EFA_SUB_BLOCKS_NORMAL_GMT: ProductTimeMap = {
  [UKEnergyProduct.EFA1A]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 1,
    duration: 2,
  },
  [UKEnergyProduct.EFA1B]: {
    dateOffsetDays: 0,
    startUTCHour: 1,
    endUTCHour: 3,
    duration: 2,
  },
  [UKEnergyProduct.EFA2A]: {
    dateOffsetDays: 0,
    startUTCHour: 3,
    endUTCHour: 5,
    duration: 2,
  },
  [UKEnergyProduct.EFA2B]: {
    dateOffsetDays: 0,
    startUTCHour: 5,
    endUTCHour: 7,
    duration: 2,
  },
  [UKEnergyProduct.EFA3A]: {
    dateOffsetDays: 0,
    startUTCHour: 7,
    endUTCHour: 9,
    duration: 2,
  },
  [UKEnergyProduct.EFA3B]: {
    dateOffsetDays: 0,
    startUTCHour: 9,
    endUTCHour: 11,
    duration: 2,
  },
  [UKEnergyProduct.EFA4A]: {
    dateOffsetDays: 0,
    startUTCHour: 11,
    endUTCHour: 13,
    duration: 2,
  },
  [UKEnergyProduct.EFA4B]: {
    dateOffsetDays: 0,
    startUTCHour: 13,
    endUTCHour: 15,
    duration: 2,
  },
  [UKEnergyProduct.EFA5A]: {
    dateOffsetDays: 0,
    startUTCHour: 15,
    endUTCHour: 17,
    duration: 2,
  },
  [UKEnergyProduct.EFA5B]: {
    dateOffsetDays: 0,
    startUTCHour: 17,
    endUTCHour: 19,
    duration: 2,
  },
  [UKEnergyProduct.EFA6A]: {
    dateOffsetDays: 0,
    startUTCHour: 19,
    endUTCHour: 21,
    duration: 2,
  },
  [UKEnergyProduct.EFA6B]: {
    dateOffsetDays: 0,
    startUTCHour: 21,
    endUTCHour: 23,
    duration: 2,
  },
};

export const EFA_SUB_BLOCKS_NORMAL_BST: ProductTimeMap = {
  [UKEnergyProduct.EFA1A]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 0,
    duration: 2,
  },
  [UKEnergyProduct.EFA1B]: {
    dateOffsetDays: 0,
    startUTCHour: 0,
    endUTCHour: 2,
    duration: 2,
  },
  [UKEnergyProduct.EFA2A]: {
    dateOffsetDays: 0,
    startUTCHour: 2,
    endUTCHour: 4,
    duration: 2,
  },
  [UKEnergyProduct.EFA2B]: {
    dateOffsetDays: 0,
    startUTCHour: 4,
    endUTCHour: 6,
    duration: 2,
  },
  [UKEnergyProduct.EFA3A]: {
    dateOffsetDays: 0,
    startUTCHour: 6,
    endUTCHour: 8,
    duration: 2,
  },
  [UKEnergyProduct.EFA3B]: {
    dateOffsetDays: 0,
    startUTCHour: 8,
    endUTCHour: 10,
    duration: 2,
  },
  [UKEnergyProduct.EFA4A]: {
    dateOffsetDays: 0,
    startUTCHour: 10,
    endUTCHour: 12,
    duration: 2,
  },
  [UKEnergyProduct.EFA4B]: {
    dateOffsetDays: 0,
    startUTCHour: 12,
    endUTCHour: 14,
    duration: 2,
  },
  [UKEnergyProduct.EFA5A]: {
    dateOffsetDays: 0,
    startUTCHour: 14,
    endUTCHour: 16,
    duration: 2,
  },
  [UKEnergyProduct.EFA5B]: {
    dateOffsetDays: 0,
    startUTCHour: 16,
    endUTCHour: 18,
    duration: 2,
  },
  [UKEnergyProduct.EFA6A]: {
    dateOffsetDays: 0,
    startUTCHour: 18,
    endUTCHour: 20,
    duration: 2,
  },
  [UKEnergyProduct.EFA6B]: {
    dateOffsetDays: 0,
    startUTCHour: 20,
    endUTCHour: 22,
    duration: 2,
  },
};

export const EFA_SUB_BLOCKS_OCTOBER_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.EFA1A]: {
    dateOffsetDays: -1,
    startUTCHour: 22,
    endUTCHour: 0,
    duration: 2,
  },
  [UKEnergyProduct.EFA1B]: {
    dateOffsetDays: 0,
    startUTCHour: 0,
    endUTCHour: 3,
    duration: 3,
  },
};

export const EFA_SUB_BLOCKS_MARCH_CLOCK_CHANGE: ProductTimeMap = {
  [UKEnergyProduct.EFA1A]: {
    dateOffsetDays: -1,
    startUTCHour: 23,
    endUTCHour: 1,
    duration: 2,
  },
  [UKEnergyProduct.EFA1B]: {
    dateOffsetDays: 0,
    startUTCHour: 1,
    endUTCHour: 2,
    duration: 1,
  },
};
